import React, { useState } from 'react';
export function PricingSection() {
  const [selected, setSelected] = useState('adaptaciones');
  const options = {
    estandar: {
      url: 'https://www.profepack.com/cart/48115364626688:1',
      buttonText: '→ SÍ, QUIERO EL MEGAPACK SECUNDARIA →'
    },
    adaptaciones: {
      url: 'https://www.profepack.com/cart/48097187004672:1',
      buttonText: '→ SÍ, QUIERO EL MEGAPACK + ADAPTACIONES →'
    }
  };
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-266">
      <div className="max-w-2xl mx-auto" data-id="element-267">
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-3" data-id="element-268">
          Elegí tu <span className="text-[#00E68A]" data-id="element-269">PROFEPACK:</span>
        </h2>
        <p className="text-gray-300 text-center text-xs sm:text-base mb-8 sm:mb-12" data-id="element-270">
          Las dos opciones incluyen los 6 bonos estratégicos
        </p>

        <div className="flex flex-col gap-6 mb-8" data-id="element-271">
          {/* Option 1: MegaPack Secundaria */}
          <button onClick={() => setSelected('estandar')} className={`w-full text-left rounded-2xl p-5 sm:p-6 transition-all ${selected === 'estandar' ? 'border-2 border-[#00E68A] shadow-[0_0_30px_rgba(0,230,138,0.15)] bg-[#0a0a0a]' : 'border border-white/10 bg-black'}`} data-id="element-272">
            <div className="flex items-center justify-between" data-id="element-273">
              <div className="flex items-center gap-3" data-id="element-274">
                <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selected === 'estandar' ? 'border-[#00E68A]' : 'border-white/30'}`} data-id="element-275">
                  {selected === 'estandar' && <div className="w-3 h-3 rounded-full bg-[#00E68A]" data-id="element-276" />}
                </div>
                <div data-id="element-277">
                  <div className="flex items-center gap-2" data-id="element-278">
                    <span className="text-xl" data-id="element-279">📗</span>
                    <h3 className="text-white font-black text-base sm:text-lg" data-id="element-280">
                      MEGAPACK SECUNDARIA
                    </h3>
                  </div>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-281">
                    6 tomos + 6 bonos
                  </p>
                </div>
              </div>
              <div className="text-right flex-shrink-0 ml-4" data-id="element-282">
                <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-283">
                  $53.000
                </div>
                <div className="font-black text-2xl sm:text-3xl text-white" data-id="element-284">
                  $19.990
                </div>
              </div>
            </div>
          </button>

          {/* Option 2: MegaPack + Adaptaciones */}
          <button onClick={() => setSelected('adaptaciones')} className={`w-full text-left rounded-2xl p-5 sm:p-6 transition-all relative ${selected === 'adaptaciones' ? 'border-2 border-[#00E68A] shadow-[0_0_30px_rgba(0,230,138,0.15)] bg-[#0a100d]' : 'border border-white/10 bg-black'}`} data-id="element-285">
            <div className="flex items-center justify-between" data-id="element-286">
              <div className="flex items-center gap-3" data-id="element-287">
                <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selected === 'adaptaciones' ? 'border-[#00E68A]' : 'border-white/30'}`} data-id="element-288">
                  {selected === 'adaptaciones' && <div className="w-3 h-3 rounded-full bg-[#00E68A]" data-id="element-289" />}
                </div>
                <div data-id="element-290">
                  <div className="flex items-center gap-2" data-id="element-291">
                    <span className="text-xl" data-id="element-292">🏆</span>
                    <h3 className="text-white font-black text-base sm:text-lg" data-id="element-293">
                      MEGAPACK + ADAPTACIONES
                    </h3>
                  </div>
                  <div className="flex flex-wrap items-center gap-2 mt-1.5" data-id="element-294">
                    <span className="bg-[#00E68A] text-gray-900 text-xs font-black px-2.5 py-0.5 rounded-full" data-id="element-295">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-[#00E68A]/10 border border-[#00E68A]/40 text-[#00E68A] text-xs font-bold px-2.5 py-0.5 rounded-full" data-id="element-296">
                      AHORRÁS $41.010
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm mt-1.5" data-id="element-297">
                    6 tomos + 6 bonos + Kit Adaptaciones Curriculares &amp;
                    Inclusión
                  </p>
                </div>
              </div>
              <div className="text-right flex-shrink-0 ml-4" data-id="element-298">
                <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-299">
                  $69.000
                </div>
                <div className="font-black text-2xl sm:text-3xl text-[#00E68A]" data-id="element-300">
                  $27.990
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* Single shared CTA button */}
        <a href={options[selected as keyof typeof options].url} className="block w-full text-center bg-[#00E68A] text-gray-900 font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl hover:bg-[#00CC7A] transition-colors btn-bordo-pulse mb-4" data-id="element-301">
          {options[selected as keyof typeof options].buttonText}
        </a>

        <p className="text-gray-400 text-xs sm:text-sm text-center italic mb-8" data-id="element-302">
          La opción más elegida por docentes con aulas heterogéneas y alumnos
          con necesidades específicas
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-300 bg-[#0a0a0a] border border-white/10 rounded-xl py-3 sm:py-4 px-4 sm:px-6" data-id="element-303">
          <span data-id="element-304">🔒 Pago seguro</span>
          <span data-id="element-305">⚡ Acceso en 5 min</span>
          <span data-id="element-306">🛡️ Garantía 7 días</span>
          <span data-id="element-307">💳 Mercado Pago</span>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-white/10 rounded-2xl overflow-hidden mt-8" data-id="element-308">
          <div className="overflow-x-auto" data-id="element-309">
            <table className="w-full text-sm text-left" data-id="element-310">
              <thead className="bg-white/5 border-b border-white/10" data-id="element-311">
                <tr data-id="element-312">
                  <th className="px-4 sm:px-6 py-4 font-bold text-white" data-id="element-313">
                    ¿Qué incluye?
                  </th>
                  <th className="px-4 sm:px-6 py-4 font-bold text-center text-white w-32" data-id="element-314">
                    MEGAPACK
                  </th>
                  <th className="px-4 sm:px-6 py-4 font-bold text-center text-[#00E68A] w-32" data-id="element-315">
                    MEGAPACK + ADAPTACIONES
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5" data-id="element-316">
                <tr className="hover:bg-white/5 transition-colors" data-id="element-317">
                  <td className="px-4 sm:px-6 py-3 text-gray-300" data-id="element-318">
                    6 Tomos (1° a 6°) + 6 Bonos Estratégicos
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-319">
                    ✅
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-320">
                    ✅
                  </td>
                </tr>
                <tr className="hover:bg-white/5 transition-colors" data-id="element-321">
                  <td className="px-4 sm:px-6 py-3 text-gray-300" data-id="element-322">
                    Planificación anual + solucionario completo
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-323">
                    ✅
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-324">
                    ✅
                  </td>
                </tr>
                <tr className="hover:bg-white/5 transition-colors" data-id="element-325">
                  <td className="px-4 sm:px-6 py-3 text-gray-300" data-id="element-326">
                    Evaluaciones y rúbricas alineadas a NAP
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-327">
                    ✅
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-328">
                    ✅
                  </td>
                </tr>
                <tr className="bg-[#0a100d] border-t border-[#00E68A]/30" data-id="element-329">
                  <td className="px-4 sm:px-6 py-3 font-bold text-[#00E68A]" data-id="element-330">
                    Kit Adaptaciones al Aula Real
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-gray-600" data-id="element-331">
                    ❌
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-332">
                    ✅
                  </td>
                </tr>
                <tr className="bg-[#0a100d]/50 hover:bg-white/5 transition-colors" data-id="element-333">
                  <td className="px-4 sm:px-6 py-3 text-gray-300 pl-8" data-id="element-334">
                    3 versiones por unidad + evaluaciones diferenciadas
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-gray-600" data-id="element-335">
                    ❌
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-336">
                    ✅
                  </td>
                </tr>
                <tr className="bg-[#0a100d]/50 hover:bg-white/5 transition-colors" data-id="element-337">
                  <td className="px-4 sm:px-6 py-3 text-gray-300 pl-8" data-id="element-338">
                    Fichas de Lectura Fácil + Protocolo Aula Abierta
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-gray-600" data-id="element-339">
                    ❌
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-340">
                    ✅
                  </td>
                </tr>
                <tr className="bg-[#0a100d]/50 hover:bg-white/5 transition-colors" data-id="element-341">
                  <td className="px-4 sm:px-6 py-3 text-gray-300 pl-8" data-id="element-342">
                    Plantillas PPI + kit legal para directivos y familias
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-gray-600" data-id="element-343">
                    ❌
                  </td>
                  <td className="px-4 sm:px-6 py-3 text-center text-green-400" data-id="element-344">
                    ✅
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}